<div class="bc-makePayment-Div">
  <span class="back-To-makePayment">
    <img src="img/chevron-left.svg" alt="left" class="svg-Images" />
    <a
      href="javascript: void(0);"
      [routerLink]="['/', 'my-account/invoices']"
      class="blue underline">
      Back to make a payment
    </a>
  </span>
</div>
<section class="row makePaymentView" id="productList-area">
  <section
    class="col-md-10 col-sm-9 order-history-right float-right invoice-paymentreview">
    <app-payment-header
      [tableCategory]="creditInvoice"
    selectedHeader="review"></app-payment-header>
    @if (invoicePaymentList?.length > 0) {
      <section>
        <section class="col-xs-12 col-sm-8 col-md-8 p0">
          <section
            class="col-xs-12 col-sm-12 col-md-12 p0 Fields-container register-zip reviewpayname">
            <label class="Fields-label step2-name">
              {{ 'makeAPayment.nameofPersonAuthorizingPayment' | cxTranslate }}
              <span>{{ personName }}</span>
            </label>
            <label class="Fields-label step2-name">
              {{ 'makeAPayment.EmailforConfirmation' | cxTranslate }}
              @if (!isAsmEnabled) {
                <span>{{ userData?.email }}</span>
              }
              @if (
                isAsmEnabled &&
                asmEmailDetails?.selectedEmail !== 'Add Other E-mail Address'
                ) {
                <span
                  >
                  {{ asmEmailDetails?.selectedEmail }}
                </span>
              }
              @if (
                isAsmEnabled &&
                asmEmailDetails?.selectedEmail === 'Add Other E-mail Address'
                ) {
                <span
                  >
                  {{ asmEmailDetails?.newEmail }}
                </span>
              }
            </label>
          </section>
        </section>
        <section class="col-md-12 tablemain-padding">
          <table
            aria-describedby="Credits"
            id="applyCreditsTable"
            class="payment-table display dataTable no-footer">
            <thead>
              <tr class="heading-table">
                <th
                  id="table1col1"
                  class="sorting"
                  tabindex="0"
                  aria-controls="applyCreditsTable"
                  aria-label="Payment-option: activate to sort column ascending">
                  {{ 'makeAPayment.payment_option' | cxTranslate }}&nbsp;
                </th>
                <th
                  id="table1col2"
                  class="sorting_desc"
                  tabindex="0"
                  aria-controls="applyCreditsTable"
                  aria-sort="descending"
                  aria-label="Invoice #: activate to sort column ascending">
                  {{ 'makeAPayment.invoice#' | cxTranslate }}
                </th>
                <th
                  id="table1col3"
                  class="sorting"
                  tabindex="0"
                  aria-controls="applyCreditsTable"
                  aria-label="Due date: activate to sort column ascending">
                  {{ 'makeAPayment.due_date' | cxTranslate }}
                </th>
                <th
                  id="table1col4"
                  class="pr8 sorting"
                  tabindex="0"
                  aria-controls="applyCreditsTable"
                  aria-label="Invoice balance: activate to sort column ascending">
                  {{ 'makeAPayment.invoice_balance' | cxTranslate }}
                </th>
                <th
                  id="table1col5"
                  class="pr8 sorting_desc"
                  tabindex="0"
                  aria-controls="applyCreditsTable"
                  aria-label="Payment amount: activate to sort column ascending">
                  {{ 'makeAPayment.payment_amount' | cxTranslate }} &nbsp;
                </th>
                <th
                  id="table1col6"
                  class="sorting payment-method"
                  tabindex="0"
                  aria-controls="applyCreditsTable"
                  aria-label="Payment method: activate to sort column ascending">
                  {{ 'makeAPayment.payment_method' | cxTranslate }}
                </th>
                <th
                  id="table1col7"
                  class="sorting"
                  tabindex="0"
                  aria-controls="applyCreditsTable"
                  aria-label="Payment date: activate to sort column ascending">
                  {{ 'makeAPayment.payment_date' | cxTranslate }}
                </th>
              </tr>
            </thead>
            <tbody class="datatable-row popup-comp">
              @for (data of invoicePaymentList; track data) {
                <tr class="odd">
                  <td headers="table1col1">
                    {{ 'makeAPayment.pay_now' | cxTranslate }}
                  </td>
                  <td headers="table1col2" class="darkblue sorting_1">
                    @if (
                      data?.docType === 'RV' ||
                      data?.docType === 'RD' ||
                      data?.docType === 'RF'
                      ) {
                      <a
                        href="javascript: void(0);"
                        class="blue underline"
                        (click)="invoicePdf(data?.refDocNo)">
                        {{ data?.refDocNo }}
                      </a>
                    }
                    @if (
                      data?.docType === 'DZ' && data?.dochdrtxt?.startsWith('7')
                      ) {
                      <a
                        href="javascript: void(0);"
                        class="blue underline"
                        (click)="invoicePdf(data?.dochdrtxt)">
                        {{ data?.dochdrtxt }}
                      </a>
                    }
                    @if (
                      data?.docType === 'DR' ||
                      data?.docType === 'DG' ||
                      data?.docType === 'DY'
                      ) {
                      <span
                        >
                        {{ data?.refDocNo }}
                      </span>
                    }
                    @if (
                      data?.docType === 'DZ' && !data?.dochdrtxt?.startsWith('7')
                      ) {
                      <span
                        >
                        {{ data?.dochdrtxt }}
                      </span>
                    }
                    @if (data?.docType === 'YR') {
                      <span>
                        {{ data?.refhdr }}
                      </span>
                    }
                    <input
                      id="invoiceDatas0.credit"
                      name="invoiceDatas[0].credit"
                      type="hidden"
                      value="92258122"
                      data-di-id="#invoiceDatas0.credit" />
                  </td>
                  <td headers="table1col3">{{ data?.dueDate }}</td>
                  <td headers="table1col4" class="text-right">
                    {{ data?.invoiceBalance | localCurrency }}
                    <input
                      id="invoiceDatas0.invoiceBalance"
                      name="invoiceDatas[0].invoiceBalance"
                      value="1479.49"
                      type="hidden"
                      data-di-id="#invoiceDatas0.invoiceBalance" />
                  </td>
                  <td headers="table1col5" class="text-right">
                    {{ data?.paymentAmount }}
                  </td>
                  <td headers="table1col6">
                    @if (selectedCardDetails?.cardType === 'VISA') {
                      <img
                        src="icons/visa.png"
                        class="card-type"
                        alt="VISA" />
                    }
                    @if (selectedCardDetails?.cardType === 'MC') {
                      <img
                        src="icons/mastercard.png"
                        class="card-type"
                        alt="MASTER"
                        />
                    }
                    #{{ dispCardNumber?.cardNumber }}
                  </td>
                  <td headers="table1col7">
                    {{ paymentDateDefault | date: 'dd/MM/yyyy' }}
                  </td>
                </tr>
              }
            </tbody>
          </table>
          <section class="credits-table-2column">
            @for (data of invoicePaymentList; track data) {
              <div
                class="row credits-row-rwd"
                >
                <div class="column creadits-header-columnrwd">
                  <section>
                    <p
                      id="table1col1"
                      class="sorting"
                      tabindex="0"
                      aria-controls="applyCreditsTable"
                      aria-label="Payment-option: activate to sort column ascending">
                      {{ 'makeAPayment.payment_option' | cxTranslate }}
                    </p>
                    <p
                      id="table1col2"
                      class="sorting_desc"
                      tabindex="0"
                      aria-controls="applyCreditsTable"
                      aria-sort="descending"
                      aria-label="Invoice #: activate to sort column ascending">
                      {{ 'makeAPayment.invoice#' | cxTranslate }}
                    </p>
                    <p
                      id="table1col3"
                      class="sorting"
                      tabindex="0"
                      aria-controls="applyCreditsTable"
                      aria-label="Due date: activate to sort column ascending">
                      {{ 'makeAPayment.due_date' | cxTranslate }}
                    </p>
                    <p
                      id="table1col4"
                      class="pr8 sorting"
                      tabindex="0"
                      aria-controls="applyCreditsTable"
                      aria-label="Invoice balance: activate to sort column ascending">
                      {{ 'makeAPayment.invoice_balance' | cxTranslate }}
                    </p>
                    <p
                      id="table1col5"
                      class="pr8 sorting_desc"
                      tabindex="0"
                      aria-controls="applyCreditsTable"
                      aria-label="Payment amount: activate to sort column ascending">
                      {{ 'makeAPayment.payment_amount' | cxTranslate }}
                    </p>
                    <p
                      id="table1col6"
                      class="sorting payment-method"
                      tabindex="0"
                      aria-controls="applyCreditsTable"
                      aria-label="Payment method: activate to sort column ascending">
                      {{ 'makeAPayment.payment_method' | cxTranslate }}
                    </p>
                    <p
                      id="table1col7"
                      class="sorting"
                      tabindex="0"
                      aria-controls="applyCreditsTable"
                      aria-label="Payment date: activate to sort column ascending">
                      {{ 'makeAPayment.payment_date' | cxTranslate }}
                    </p>
                  </section>
                </div>
                <div class="column credits-desc-column">
                  <section>
                    <p headers="table1col1">
                      {{ 'makeAPayment.pay_now' | cxTranslate }}
                    </p>
                    <p headers="table1col2" class="darkblue sorting_1">
                      @if (
                        data?.docType === 'RV' ||
                        data?.docType === 'RD' ||
                        data?.docType === 'RF'
                        ) {
                        <a
                          href="javascript: void(0);"
                          class="blue underline"
                          (click)="invoicePdf(data?.refDocNo)">
                          {{ data?.refDocNo }}
                        </a>
                      }
                      @if (
                        data?.docType === 'DZ' && data?.dochdrtxt?.startsWith('7')
                        ) {
                        <a
                          href="javascript: void(0);"
                          class="blue underline"
                          (click)="invoicePdf(data?.dochdrtxt)">
                          {{ data?.dochdrtxt }}
                        </a>
                      }
                      @if (
                        data?.docType === 'DR' ||
                        data?.docType === 'DG' ||
                        data?.docType === 'DY'
                        ) {
                        <span
                          >
                          {{ data?.refDocNo }}
                        </span>
                      }
                      @if (
                        data?.docType === 'DZ' &&
                        !data?.dochdrtxt?.startsWith('7')
                        ) {
                        <span
                          >
                          {{ data?.dochdrtxt }}
                        </span>
                      }
                      @if (data?.docType === 'YR') {
                        <span>
                          {{ data?.refhdr }}
                        </span>
                      }
                      <input
                        id="invoiceDatas0.credit"
                        name="invoiceDatas[0].credit"
                        type="hidden"
                        value="92258122"
                        data-di-id="#invoiceDatas0.credit" />
                    </p>
                    <p headers="table1col3">{{ data?.dueDate }}</p>
                    <p headers="table1col4">
                      {{ data?.invoiceBalance | localCurrency }}
                      <input
                        id="invoiceDatas0.invoiceBalance"
                        name="invoiceDatas[0].invoiceBalance"
                        value="1479.49"
                        type="hidden"
                        data-di-id="#invoiceDatas0.invoiceBalance" />
                    </p>
                    <p headers="table1col5" class="mb20">
                      {{ data?.paymentAmount }}
                    </p>
                    <p headers="table1col6" class="mb20">
                      @if (selectedCardDetails?.cardType === 'VISA') {
                        <img
                          src="icons/visa.png"
                          class="card-type"
                          alt="VISA" />
                      }
                      @if (selectedCardDetails?.cardType === 'MC') {
                        <img
                          src="icons/mastercard.png"
                          class="card-type"
                          alt="MASTER"
                          />
                      }
                      #{{ dispCardNumber?.cardNumber }}
                    </p>
                    <p headers="table1col7">
                      {{ paymentDateDefault | date: 'dd/MM/yyyy' }}
                    </p>
                  </section>
                </div>
              </div>
            }
          </section>
        </section>
        <section class="row online-invoices sec-part float-right">
          <aside
            aria-label="Pay Now"
            class="col-xs-12 float-right po-right open_aside">
            <section class="row row-20">
              <section class="col-xs-6 col-md-6">
                <h3 class="title">
                  {{ 'makeAPayment.pay_now' | cxTranslate }}
                </h3>
              </section>
              <section class="col-xs-6 col-md-6">
                <p class="total amount">
                  {{ totalInvoiceAmount | localCurrency }}
                </p>
              </section>
            </section>
            <p class="para">
              {{ 'makeAPayment.totalamountinfo' | cxTranslate }}
            </p>
            <section class="row paytotal">
              <section class="col-xs-6 col-md-6 pl0">
                <h3 class="title bold">
                  {{ 'makeAPayment.payment_total' | cxTranslate }}
                </h3>
              </section>
              <section class="col-xs-6 col-md-6 pr0">
                <p class="total bold">{{ totalInvoiceAmount | localCurrency }}</p>
              </section>
            </section>
            <button
              type="submit"
              class="reviewbtn"
              data-di-id="di-id-5896ea52-8b55cbae"
              (click)="submitPayment()">
              {{ 'makeAPayment.submitPayment' | cxTranslate }}
            </button>
            <a
              href="javascript:void(0)"
              role="presentation"
              data-di-id="di-id-7ee5cf4b-3449b0d5">
              <button type="button" (click)="back()" class="cancelbtn">
                {{ 'makeAPayment.cancel' | cxTranslate }}
              </button>
            </a>
          </aside>
        </section>
      </section>
    }

    <!-- Credit Review Table -->
    @if (creditPaymentList.length > 0) {
      <section>
        <section class="col-xs-12 col-sm-8 col-md-8 p0 p10">
          <section
            class="col-xs-12 col-sm-12 col-md-12 p0 Fields-container register-zip reviewpayname">
            <label class="Fields-label step2-name">
              {{ 'makeAPayment.nameofPersonAuthorizingPayment' | cxTranslate }}
              <span>{{ personName }}</span>
            </label>
            <label class="Fields-label step2-name">
              {{ 'makeAPayment.EmailforConfirmation' | cxTranslate }}
              @if (!isAsmEnabled) {
                <span>{{ userData?.email }}</span>
              }
              @if (
                isAsmEnabled &&
                asmEmailDetails?.selectedEmail !== 'Add Other E-mail Address'
                ) {
                <span
                  >
                  {{ asmEmailDetails?.selectedEmail }}
                </span>
              }
              @if (
                isAsmEnabled &&
                asmEmailDetails?.selectedEmail === 'Add Other E-mail Address'
                ) {
                <span
                  >
                  {{ asmEmailDetails?.newEmail }}
                </span>
              }
            </label>
          </section>
        </section>
        <section class="col-md-12 tablemain-padding sec-part">
          <table
            aria-describedby="Invoices"
            id="applyCreditsTable"
            class="credit-table display dataTable no-footer">
            <thead>
              <tr class="heading-table">
                <th
                  id="table1col1"
                  class="sorting"
                  tabindex="0"
                  aria-controls="applyCreditsTable"
                  aria-label="Payment-option: activate to sort column ascending">
                  {{ 'makeAPayment.credit#' | cxTranslate }} &nbsp;
                </th>
                <th
                  id="table1col2"
                  class="sorting_desc"
                  tabindex="0"
                  aria-controls="applyCreditsTable"
                  aria-sort="descending"
                  aria-label="Invoice #: activate to sort column ascending">
                  {{ 'makeAPayment.apply_to_invoice' | cxTranslate }} &nbsp;
                </th>
                <th
                  id="table1col3"
                  class="pr8 sorting"
                  tabindex="0"
                  aria-controls="applyCreditsTable"
                  aria-label="Due date: activate to sort column ascending">
                  {{ 'makeAPayment.credit_applied' | cxTranslate }}
                </th>
                <th
                  id="table1col4"
                  class="pr8 sorting"
                  tabindex="0"
                  aria-controls="applyCreditsTable"
                  aria-label="Invoice balance: activate to sort column ascending">
                  {{ 'makeAPayment.credit_balance' | cxTranslate }}
                </th>
                <th
                  id="table1col5"
                  class="pr8 sorting"
                  tabindex="0"
                  aria-controls="applyCreditsTable"
                  aria-label="Invoice balance: activate to sort column ascending">
                  {{ 'makeAPayment.invoice_balance' | cxTranslate }} &nbsp;
                </th>
                <th
                  id="table1col6"
                  class="sorting"
                  tabindex="0"
                  aria-controls="applyCreditsTable"
                  aria-label="Payment method: activate to sort column ascending">
                  {{ 'makeAPayment.credit_applied_date' | cxTranslate }}
                </th>
              </tr>
            </thead>
            <tbody class="datatable-row popup-comp">
              @for (data of creditPaymentList; track data) {
                <tr class="odd">
                  <td headers="table1col1" class="sorting_1">
                    @if (
                      data?.docType === 'RV' ||
                      data?.docType === 'RD' ||
                      data?.docType === 'RF'
                      ) {
                      <a
                        href="javascript: void(0);"
                        class="underline"
                        (click)="creditPdf(data?.refDocNo)">
                        {{ data?.refDocNo }}
                      </a>
                    }
                    @if (
                      data?.docType === 'DZ' && data?.dochdrtxt?.startsWith('7')
                      ) {
                      <a
                        href="javascript: void(0);"
                        class="underline"
                        (click)="creditPdf(data?.dochdrtxt)">
                        {{ data?.dochdrtxt }}
                      </a>
                    }
                    @if (
                      data?.docType === 'DR' ||
                      data?.docType === 'DG' ||
                      data?.docType === 'DY'
                      ) {
                      <span
                        >
                        {{ data?.refDocNo }}
                      </span>
                    }
                    @if (
                      data?.docType === 'DZ' && !data?.dochdrtxt?.startsWith('7')
                      ) {
                      <span
                        >
                        {{ data?.dochdrtxt }}
                      </span>
                    }
                    @if (data?.docType === 'YR') {
                      <span>
                        {{ data?.refhdr }}
                      </span>
                    }
                  </td>
                  <td headers="table1col2">{{ data?.applyToInvoice }}</td>
                  <td headers="table1col3" class="right-text">
                    {{ data?.creditsApplied | localCurrency }}
                  </td>
                  <td headers="table1col4" class="right-text">
                    {{ data?.creditBalance | localCurrency }}
                  </td>
                  <td headers="table1col5" class="right-text">
                    {{ data?.invoiceBalance | localCurrency }}
                  </td>
                  <td headers="table1col6">
                    {{ paymentDateDefault | date: 'dd/MM/yyyy' }}
                  </td>
                </tr>
              }
            </tbody>
          </table>
          <section class="invoicepayment-table-2column">
            @for (data of creditPaymentList; track data) {
              <div
                class="row invoice-2col-row-rwd"
                >
                <div class="column invoice-header-rwd">
                  <section>
                    <p
                      id="table1col1"
                      class="sorting"
                      tabindex="0"
                      aria-controls="applyCreditsTable"
                      aria-label="Payment-option: activate to sort column ascending">
                      {{ 'makeAPayment.credit#' | cxTranslate }} &nbsp;
                    </p>
                    <p
                      id="table1col2"
                      class="sorting_desc"
                      tabindex="0"
                      aria-controls="applyCreditsTable"
                      aria-sort="descending"
                      aria-label="Invoice #: activate to sort column ascending">
                      {{ 'makeAPayment.apply_to_invoice' | cxTranslate }} &nbsp;
                    </p>
                    <p
                      id="table1col3"
                      class="pr8 sorting"
                      tabindex="0"
                      aria-controls="applyCreditsTable"
                      aria-label="Due date: activate to sort column ascending">
                      {{ 'makeAPayment.credit_applied' | cxTranslate }}
                    </p>
                    <p
                      id="table1col4"
                      class="pr8 sorting"
                      tabindex="0"
                      aria-controls="applyCreditsTable"
                      aria-label="Invoice balance: activate to sort column ascending">
                      {{ 'makeAPayment.credit_balance' | cxTranslate }}
                    </p>
                    <p
                      id="table1col5"
                      class="pr8 sorting"
                      tabindex="0"
                      aria-controls="applyCreditsTable"
                      aria-label="Invoice balance: activate to sort column ascending">
                      {{ 'makeAPayment.invoice_balance' | cxTranslate }} &nbsp;
                    </p>
                    <p
                      id="table1col6"
                      class="sorting"
                      tabindex="0"
                      aria-controls="applyCreditsTable"
                      aria-label="Payment method: activate to sort column ascending">
                      {{ 'makeAPayment.credit_applied_date' | cxTranslate }}
                    </p>
                  </section>
                </div>
                <div class="column invoice-desc-column">
                  <section>
                    <p headers="table1col1" class="sorting_1">
                      @if (
                        data?.docType === 'RV' ||
                        data?.docType === 'RD' ||
                        data?.docType === 'RF'
                        ) {
                        <a
                          href="javascript: void(0);"
                          class="underline"
                          (click)="creditPdf(data?.refDocNo)">
                          {{ data?.refDocNo }}
                        </a>
                      }
                      @if (
                        data?.docType === 'DZ' && data?.dochdrtxt?.startsWith('7')
                        ) {
                        <a
                          href="javascript: void(0);"
                          class="underline"
                          (click)="creditPdf(data?.dochdrtxt)">
                          {{ data?.dochdrtxt }}
                        </a>
                      }
                      @if (
                        data?.docType === 'DR' ||
                        data?.docType === 'DG' ||
                        data?.docType === 'DY'
                        ) {
                        <span
                          >
                          {{ data?.refDocNo }}
                        </span>
                      }
                      @if (
                        data?.docType === 'DZ' &&
                        !data?.dochdrtxt?.startsWith('7')
                        ) {
                        <span
                          >
                          {{ data?.dochdrtxt }}
                        </span>
                      }
                      @if (data?.docType === 'YR') {
                        <span>
                          {{ data?.refhdr }}
                        </span>
                      }
                    </p>
                    <p headers="table1col2" class="table1col2">
                      {{ data?.applyToInvoice }}
                    </p>
                    <p headers="table1col3" class="right-text">
                      {{ data?.creditsApplied | localCurrency }}
                    </p>
                    <p headers="table1col4" class="right-text">
                      {{ data?.creditBalance | localCurrency }}
                    </p>
                    <p headers="table1col5" class="right-text">
                      {{ data?.invoiceBalance | localCurrency }}
                    </p>
                    <p headers="table1col6">
                      {{ paymentDateDefault | date: 'dd/MM/yyyy' }}
                    </p>
                  </section>
                </div>
              </div>
            }
          </section>
          <section class="invoice-btngrps">
            <a
              href="javascript:void(0)"
              class="focusnone"
              tabindex="-1"
              data-di-id="di-id-9f8fe96-b6e2fb87">
              <button
                type="button"
                (click)="back()"
                class="btn btn-default oi-white-button">
                {{ 'makeAPayment.back_btn' | cxTranslate }}
              </button>
            </a>
            <button
              type="button"
              class="btn btn-default oi-blue-button reviewvalidbtn"
              (click)="applyCredits()"
              data-di-id="di-id-7a6cb2cd-cb37948a">
              {{ 'makeAPayment.credit_title' | cxTranslate }}
            </button>
          </section>
        </section>
      </section>
    }
  </section>
</section>
